import React from "react";
import { Navigate, generatePath, useParams } from "react-router-dom";

function ThemePage() {
  const { ThemeName } = useParams();

  if (!ThemeName) {
    return <Navigate to="/Occasions" replace />;
  }

  const mappedTheme = ThemeName.toLowerCase() === "home" ? "New-Home" : ThemeName;

  return (
    <Navigate
      to={generatePath("/Occasions/:OccasionName", {
        OccasionName: mappedTheme,
      })}
      replace
    />
  );
}

export default ThemePage;



